export const enum UserType {
  DEFAULT = 'DEFAULT',
  LUX_ENGINE = 'LUX_ENGINE'
}
